module.exports = __webpack_public_path__ + "img/ella.e78edcad.svg";